import { render, staticRenderFns } from "./LandingPageDefault.vue?vue&type=template&id=1c01c71a&scoped=true&"
import script from "./LandingPageDefault.vue?vue&type=script&lang=js&"
export * from "./LandingPageDefault.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageDefault.vue?vue&type=style&index=0&id=1c01c71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01c71a",
  null
  
)

export default component.exports